import moment from "moment/moment";
import { useState } from "react";
import UpgradeChangeRequestModal from "./UpgradeChangeRequestsModal";

const StatusBadge = ({ status }) => {
  if (!status) return <span className="text-[#757575]">-</span>;

  const config = {
    Approved: { bg: "bg-green-50", text: "text-green-700", border: "border-green-200", dot: "bg-green-500" },
    Submitted: { bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200", dot: "bg-blue-500" },
    Rejected:  { bg: "bg-red-50",  text: "text-[#c00000]", border: "border-red-200",  dot: "bg-[#c00000]" },
    Pending:   { bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", dot: "bg-amber-500" },
  };

  const c = config[status] ?? { bg: "bg-gray-50", text: "text-[#757575]", border: "border-[#c9c9c9]", dot: "bg-[#757575]" };

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${c.bg} ${c.text} ${c.border}`}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${c.dot}`} />
      {status}
    </span>
  );
};

function UpgradeChangeRequests(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [requestType, setRequestType] = useState("");

  return (
    <div className="bg-white border border-[#c9c9c9]">

      {/* Table */}
      <div className="px-7 pb-7 pt-4 overflow-x-auto">
        <table className="w-full bg-white">
          <thead>
            <tr className="border-b border-[#c9c9c9]">
              <th className="py-2 pr-4 text-left text-sm font-semibold text-[#757575] whitespace-nowrap">
                Request Type
              </th>
              <th className="py-2 pr-4 text-left text-sm font-semibold text-[#757575] whitespace-nowrap">
                Submitted On
              </th>
              <th className="py-2 pr-4 text-left text-sm font-semibold text-[#757575] whitespace-nowrap">
                Status
              </th>
              <th className="py-2 pr-4 text-left text-sm font-semibold text-[#757575] whitespace-nowrap">
                Approved / Processed On
              </th>
              <th className="py-2 pr-4 text-left text-sm font-semibold text-[#757575] whitespace-nowrap">
                Processed By
              </th>
              <th className="py-2 text-left text-sm font-semibold text-[#757575] whitespace-nowrap">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="text-sm custom-tbody">
            {props.upgradeChangeRequestData && props.upgradeChangeRequestData.length > 0 ? (
              props.upgradeChangeRequestData.map((item, index) => (
                <tr key={index} className="custom-tbl-td-contribution border-b border-[#c9c9c9] last:border-0">
                  <td className="py-4 pr-4 whitespace-nowrap text-[#c00000] text-base font-bold text-left">
                    {item.requestType || "-"}
                  </td>
                  <td className="py-3 pr-4 whitespace-nowrap text-[#757575] text-base text-left">
                    {item.submittedOn ? moment(item.submittedOn).format("DD/MM/YYYY") : "-"}
                  </td>
                  <td className="py-3 pr-4 whitespace-nowrap text-left">
                    <StatusBadge status={item.status} />
                  </td>
                  <td className="py-3 pr-4 whitespace-nowrap text-[#757575] text-base text-left">
                    {item.approvedProcessedOn ? moment(item.approvedProcessedOn).format("DD/MM/YYYY") : "-"}
                  </td>
                  <td className="py-3 pr-4 whitespace-nowrap text-[#757575] text-base text-left">
                    {item.processedBy || "-"}
                  </td>
                  <td className="py-3 whitespace-nowrap text-left">
                    <button
                      className="underline text-base text-[#8DA4B5] hover:text-[#657d8e] transition-colors"
                      onClick={() => {
                        setRequestType(item.requestType);
                        props.getUpgradeChangeRequestDetailsbyRequestId(
                          item.upgradeChangeRequestId,
                          item.requestType
                        );
                        setIsModalOpen(true);
                      }}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-8 text-base text-[#757575]">
                  No Records Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <UpgradeChangeRequestModal
          setIsModalOpen={setIsModalOpen}
          upgradeChangeRequestDataInfo={
            props.upgradeChangeRequestDataBasedOnUpgradeChangeRequestIdData
          }
          reqType={requestType}
        />
      )}
    </div>
  );
}

export default UpgradeChangeRequests;
